import { convertValues } from '~/util';

import { client } from './client/Client';

const convertCardResponse = (response: any): Card => {
  const card = convertValues<Card>(response, undefined, {
    lastFourDigits: response.lastFourDigits || response.last_four_digits,
    authorizedUserEntityId: response.authorizedUserEntityId || response.authorized_user_entity_id,
  });
  const rawDate = response.createdAt || response.created_at;
  if (rawDate) {
    card.createdAt = new Date(rawDate);
  }
  return card;
};

export interface Card {
  id: string;
  cardAccountId: string;
  cardProgramId: string;
  authorizedUserEntityId: string;
  bin: string;
  status: string;
  type: string;
  lastFourDigits: string;
  expiresAt: string;
  createdAt: Date;
}

interface ListCardsResponse {
  cards: Card[];
  hasMore: boolean;
}

interface ListCardsParams {
  cardAccountId?: string;
}

export class CardRepository {
  static async pause(id: string): Promise<Card> {
    return client.patch<unknown, Card>(`/cards/${id}/pause`, {}).then((response) => {
      return convertCardResponse(response);
    });
  }

  static async activate(id: string): Promise<Card> {
    return client.patch<unknown, Card>(`/cards/${id}/activate`, {}).then((response) => {
      return convertCardResponse(response);
    });
  }

  static async get(id: string): Promise<Card> {
    return client.get<unknown, Card>(`/cards/${id}`).then((response) => {
      return convertCardResponse(response);
    });
  }

  static async listCards(query?: ListCardsParams): Promise<ListCardsResponse> {
    try {
      return await client.get<ListCardsParams, ListCardsResponse>('/cards', { query }).then((response) => ({
        cards: Array.isArray(response?.cards)
          ? response.cards.map((e) => {
              const card = convertValues<Card>(e, undefined, {
                lastFourDigits: (e as any).lastFourDigits || (e as any).last_four_digits,
                authorizedUserEntityId: (e as any).authorizedUserEntityId || (e as any).authorized_user_entity_id,
              });
              // Ensure createdAt is a Date even if it came back as a string or with unexpected key mapping
              const rawDate = (e as any).createdAt || (e as any).created_at;
              if (rawDate && (typeof card.createdAt === 'string' || !card.createdAt)) {
                card.createdAt = new Date(rawDate);
              }
              return card;
            })
          : [],
        hasMore: Boolean(response?.hasMore),
      }));
    } catch (error) {
      console.error('Failed to fetch cards:', error);
      return { cards: [], hasMore: false };
    }
  }
}
